import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

/**
 * Hook for a temporary value that renews its time to live everytime it's updated.
 */
export const useDebouncedTemporaryValue = <T>(
  initialValue: T,
  timeToLive = 500,
): [T, Dispatch<SetStateAction<T>>] => {
  const [value, setValue] = useState(initialValue);
  const timeoutId = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (value === initialValue) {
      return;
    }

    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
      timeoutId.current = null;
    }

    timeoutId.current = setTimeout(() => {
      setValue(initialValue);
      timeoutId.current = null;
    }, timeToLive);
  }, [value, timeToLive, initialValue]);

  return [value, setValue];
};
